module.exports = __webpack_public_path__ + "a516c00b0454df56b607035c07bc39ba.png";